import { ProjectsService } from "../../services/projects/projects.service";
import { HttpClient } from "@angular/common/http";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";

@Component({
  selector: "app-account-statement",
  templateUrl: "./account-statement.component.html",
  styleUrls: ["./account-statement.component.scss"],
})
export class AccountStatementComponent implements OnInit {
  leads: Array<any> = [];
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  last_page_url: any;
  prev_page_url: any;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;
  is_refreshing = false;
  per_page: any;
  total: any;
  current_page: any = 1;
  leads_raw_data: any;
  manageTable: any = {
    lead_name: true,
    unit_serial: true,
    status: true,
    building: true,
    garden_area: true,
    price: true,
    date: true,
    agent: true,
    contract_generated: false,
    unit_area: true,
  };
  toogleManageTable = {
    lead_name: false,
    unit_serial: false,
    status: false,
    building: false,
    garden_area: false,
    price: false,
    date: false,
    agent: false,
    contract_generated: true,
    unit_area: false,
  };
  reservation = {
    onColor: "primary",
    offColor: "danger",
    onText: "Enable",
    offText: "Disable",
    value: "",
    size: "",
  };
  lg = "lg";
  projects: any;

  active_tab: any = "filter";
  constructor(
    private router: Router,
    public fb: FormBuilder,
    public slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    public leadsService: LeadsService,
    private http: HttpClient,
    public projectService: ProjectsService
  ) {}

  ngOnInit() {
    this.createForms();
    this.getLeads();
  }

  createForms() {
    this.filterForm = this.fb.group({
      unit_id: [""],
      agent: [""],
      keyword: [""],
      is_client: [1],
    });
  }

  getLeads() {
    this.slimLoadingBarService.start();
    this.leadsService
      .getLeads({ ...this.filterForm.value, page: this.current_page })
      .subscribe((data: any) => {
        this.leads_raw_data = data;
        this.leads = data.data.map((lead) => {
          lead.phones = [
            lead.phone,
            lead.phone_2,
            lead.phone_3,
            lead.phone_4,
            lead.phone_5,
            lead.phone_6,
          ]
            .filter((a) => a)
            .join(", ");

          return lead;
        });
        this.last_page_url = data.last_page_url;
        this.per_page = data.to;
        this.total = data.total;
        this.slimLoadingBarService.complete();
      }),
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      };
  }

  resetFilters() {
    this.createForms();
    this.getLeads();
  }

  pageChange(event) {
    this.current_page = event;
    this.getLeads();
  }

  toggleChange($event, type) {
    this.manageTable[type] = !$event;
  }

  viewReservation(reservation) {
    window.localStorage.setItem(
      "reservationDetails",
      JSON.stringify(reservation)
    );
    this.router.navigate(["/pages/project/view-reservation"]);
  }

  gotoUnitView(reservation) {
    if (this.isCustomerCare() == true) return;
    this.router.navigate(["/pages/projects/view-unit"], {
      queryParams: {
        project_id: reservation.unit.project.id,
        unit_id: reservation.unit.id,
      },
    });
  }

  setFilterActiveTab() {
    if (this.active_tab == "" || this.active_tab == "sales-status") {
      this.active_tab = "filter";
    } else {
      this.active_tab = "";
    }
  }

  setSalesStatusTab() {
    if (this.active_tab == "" || this.active_tab == "filter") {
      this.active_tab = "sales-status";
    } else {
      this.active_tab = "";
    }
  }

  isCustomerCare() {
    return this.userProfile.role == "Customer Care" ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/account-statement/account-statement.component.ts